{
    "TelephoneserverLabel": "Serveur téléphonique :",
    "PartitionsLabel": "Partition(s) :",
    "ScopeFiltering_SectionHeader": "Filtrage de la portée",
    "NAME": "ScopeFiltering"
}